/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Mail, Lock } from "lucide-react";
import TextInput from "../ui/TextInput";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { RootState } from "../../redux/app/store";
import Button from "../ui/Button";
import AuthPageWrapper from "./AuthPageWrapper";
import { login } from "../../redux/features/authSlice";
import { useAppDispatch } from "../../redux/app/hooks";

const LoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { authenticatingUser, isAuthenticated, user } = useSelector(
    (state: RootState) => state.auth
  );

  // -------------------------
  // Local form state
  // -------------------------
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Error states
  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  // -------------------------
  // Validation + Submit
  // -------------------------
  const validateForm = () => {
    let isValid = true;

    // Reset errors
    setEmailError(null);
    setPasswordError(null);

    if (!email.trim()) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!email.includes("@")) {
      setEmailError("Enter a valid email");
      isValid = false;
    }

    if (!password.trim()) {
      setPasswordError("Password is required");
      isValid = false;
    }

    return isValid;
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      await dispatch(login({ email, password })).unwrap();
      navigate("/dashboard", { replace: true });
    } catch (err: any) {
      console.log(err?.message || "Login failed");
    }
  };

  // Redirect if already logged in
  useEffect(() => {
    if (isAuthenticated && user) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, user]);

  return (
    <AuthPageWrapper
      title="Welcome to Intersida"
      sub_title={
        <>
          Don't have an account?
          <Link to="/signup" className="text-accent hover:underline ml-2">
            Create an account
          </Link>
        </>
      }
    >
      <form className="space-y-4 w-full md:w-[450px]" onSubmit={onSubmit}>
        <TextInput
          id="email"
          type="email"
          label="Email Address"
          placeholder="Enter your email"
          icon={<Mail className="w-5 h-5 text-gray-400" />}
          value={email}
          onChange={(e: any) => setEmail(e.target.value)}
          error={emailError || undefined}
        />

        <TextInput
          id="password"
          type="password"
          label="Password"
          placeholder="Enter your password"
          icon={<Lock className="w-5 h-5 text-gray-400" />}
          value={password}
          onChange={(e: any) => setPassword(e.target.value)}
          error={passwordError || undefined}
        />

        <div className="text-right text-sm">
          <Link to="/forgot-password" className="text-accent hover:underline">
            Forgot password?
          </Link>
        </div>
        <Button label="Sign In" type="submit" isLoading={authenticatingUser} />
      </form>
    </AuthPageWrapper>
  );
};

export default LoginPage;
